export function CourseTypeLabel(type) {
  if (type === 'Online') return 'Self Paced'
  if (type === 'Webinar') return 'Online'
  if (type === 'Classroom') return 'Classroom'
  return type
}

export function CourseTypeRequiresBatch(type) {
  return type === 'Webinar' || type === 'Classroom'
}

export function BatchRequiredMessage(type) {
  return `${CourseTypeLabel(type)} requires a batch. Select start date, end date, and time.`
}

export function BatchSelectMessage(type) {
  return `Select a ${CourseTypeLabel(type)} batch.`
}

export function ScheduleTypeLabel(type) {
  if (type === 'Classroom') return 'Classroom'
  if (type === 'Webinar' || type === 'Online' || type === 'Live Online') return 'Online'
  return type
}

export function CourseIdOf(doc) {
  if (!doc) return ''
  if (doc.Course_Id && doc.Course_Id._id) return String(doc.Course_Id._id)
  if (doc.Course_Id) return String(doc.Course_Id)
  if (doc.CourseDetails && doc.CourseDetails._id) return String(doc.CourseDetails._id)
  return ''
}

export function MatchesScheduleType(schedule, courseType) {
  const type = ((schedule && schedule.Schedule_Type) || '').toString()
  if (!type) return true
  if (courseType === 'Webinar') return ['Webinar', 'Online', 'Live Online'].indexOf(type) !== -1
  return type === courseType
}

export function SchedulesForCourseType(list, courseType) {
  const schedules = list || []
  if (!CourseTypeRequiresBatch(courseType)) return []
  const matched = schedules.filter(schedule => MatchesScheduleType(schedule, courseType))
  return matched.length ? matched : schedules
}
